import { graphql } from 'graphql'
import cookies from 'js-cookie'
import { ApiConnector } from '../api/connector/api-connector'
import { schema, getMockSchema } from './schema'
export { schema }

function createContext() {
  return {
    connector: new ApiConnector(
      fetch,
      cookies,
      document.location,
      window.localStorage
    )
  }
}

export { createContext, getMockSchema }

// Will be removed when GridLoader is refactored to use Apollo Client
export function graphqlQuery(gql: string, vars?: any): Promise<any> {
  return graphql(schema, gql, undefined, createContext(), vars)
}
export function mockGraphqlQuery(gql: string, vars?: any): Promise<any> {
  return graphql(schema, gql, undefined, undefined, vars)
}
